module.exports = "/packs/images/sprites/contact~a31f5993fb584dbf2ea9dfb7c37eecb0.png";